import { AppState } from '../state';
import { SessionState } from './session.reducer';
import { createSelector } from '@ngrx/store';
import { SelectedAffiliateMapped } from '@airtradeit/authentication';

export const selectSessionData = (state: AppState): SessionState => state.session;

export const selectSelectedAffiliate = createSelector(
  selectSessionData,
  ({ selectedAffiliate }: SessionState): SelectedAffiliateMapped => selectedAffiliate
);

export const selectSelectedAffiliateCode = createSelector(selectSelectedAffiliate, ({ code }: SelectedAffiliateMapped): string => code);
